import {createRoutine} from "redux-saga-routines";

export const syncPeerToPeerStatus = createRoutine('SYNC_PEER_TO_PEER_STATUS');
export const stopSyncingPeerToPeerStatus = createRoutine('STOP_SYNCING_PEER_TO_PEER_STATUS');
